// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"06a3e5d4","732":"99bcff37","977":"ae5f2e9f"}[chunkId] + ".chunk.js";
};